import React from 'react';

import { IconWarning } from '@lightspeed/flame/Icon/Warning';

import TooltipHelp from 'root/apps/Tooltip/components/TooltipHelp';

type Props = {
  content: string;
};

const WarningTooltip: React.FC<Props> = ({ content }) => (
  <TooltipHelp
    placement="top"
    width="225px"
    content={content}
    icon={
      <span className="flex">
        <IconWarning baseColor1="orange" detailsColor1="white" />
      </span>
    }
  />
);

export default WarningTooltip;
